@if (lightboxState.isOpen) {
  <div class="lightbox" id="lightbox" (touchstart)="handleTouchStart($event)"
    (touchmove)="handleTouchMove($event)" (touchend)="handleTouchEnd()">
    @if (showDownloadButton) {
      <div (click)="downloadMedia()" class="download-area">
        <span class="icon download-img"></span>
      </div>
    }
    <div (click)="closeLightbox()" id="close-btn">
      <span class="icon icon_close"></span>
    </div>
    <div class="index-display">{{ lightboxState.currentIndex + 1 }}/{{ lightboxState.items.length }}</div>
    <div class="lightbox-content">
      @if (isMediaLoading) {
        <div class="spinner-container">
          <wb-spinner></wb-spinner>
        </div>
      }
      @if (lightboxState.items[lightboxState.currentIndex]?.type === 'IMAGE' || lightboxState.items[lightboxState.currentIndex]?.type === 'PHOTOSPOT') {
        <img #imageElement [class.hidden]="isMediaLoading" [src]="lightboxState.items[lightboxState.currentIndex]?.url" alt="lightbox-content" (load)="onLoad()"
          (error)="onError()">
      } @else {
        <app-custom-video [class.hidden]="isMediaLoading" (videoLoaded)="onVideoLoaded()" #customVideo [sourceUrl]="lightboxState.items[lightboxState.currentIndex]?.url" [thumbnail_url]="lightboxState.items[lightboxState.currentIndex]?.thumbnail_url"></app-custom-video>
      }
    </div>
    <div class="button-sec">
      <button class="arrow-button left" (click)="prevItem()" [ngClass]="{ disabled: lightboxState.currentIndex === 0 }" [attr.disabled]="lightboxState.currentIndex === 0 ? true : null"></button>
      <button class="arrow-button right" (click)="nextItem()" [ngClass]="{ disabled: lightboxState.currentIndex === lightboxState.items.length - 1 }" [attr.disabled]="lightboxState.currentIndex === lightboxState.items.length - 1 ? true : null"></button>
    </div>
  </div>
}
